<template>
  <div>
    <b-card>
      <div slot="header">Compra</div>
      <b-row>
        <b-col xl="6">
          <b-form-group
            label="Proveedor"
            label-for="proveedor"
            :label-cols="2"
            horizontal>
            <b-input-group>
              <b-input-group-append 
                  class="filter-search-icons" 
                  @click="seleccionarProveedor">
                <b-input-group-text>
                  <i class="fa fa-search"></i>
                </b-input-group-text>
              </b-input-group-append>
              <b-input-group-append 
                  class="filter-search-icons" 
                  @click="agregarProveedor">
                <b-input-group-text>
                  <i class="fa fa-plus"></i>
                </b-input-group-text>
              </b-input-group-append>
              <b-form-input 
                id="proveedor"
                :value="proveedorNombre"
                :state="proveedorValido"
                readonly
                type="text"/>
              <b-form-invalid-feedback id="proveedorFeedback">
                {{ proveedorInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-input-group>
          </b-form-group>

          <div v-if="formularioVisible" class="grupo-controles">
            <b-form-group
              label="Comp."
              :label-cols="2"
              horizontal>

              <comprobante-tipo
                label="tipo de comprobante"
                selectId="comprobanteTipo"
                :showLabel="false"
                :nombre="comprobanteTipoNombre"
                :valido="comprobanteTipoValido"
                :lista="comprobantesTiposList"
                @validate="validate"
                @updated="comprobanteTipoActualizado">
              </comprobante-tipo>

              <formulario
                label="formulario"
                selectId="formulario"
                :showLabel="false"
                :nombre="formulario"
                :valido="formularioValido"
                :lista="formularios"
                :readOnly="formularioDisabled"
                @validate="validate"
                @updated="formularioActualizado">
              </formulario>

              <b-form-invalid-feedback id="comprobanteFeedback">
                {{ comprobanteInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </div>

          <b-form-group
            v-if="!formularioVisible"
            label="Comp."
            :label-cols="2"
            horizontal>

            <comprobante-tipo
              label="tipo de comprobante"
              selectId="comprobanteTipo"
              :showLabel="false"
              :nombre="comprobanteTipoNombre"
              :valido="comprobanteTipoValido"
              :lista="comprobantesTiposList"
              @validate="validate"
              @updated="comprobanteTipoActualizado">
            </comprobante-tipo>
            <b-form-invalid-feedback id="comprobanteTipoFeedback">
              {{ comprobanteInvalidoMsj }}
            </b-form-invalid-feedback>          
          </b-form-group>

          <div v-if="puntoVentaVisible" class="grupo-controles">
            <b-form-group
              label="Número"
              label-for="numero"
              :label-cols="2"
              horizontal>
              <b-form-input 
                id="numeroPuntoVenta"
                v-model.trim= "$v.numeroPuntoVenta.$model" 
                :state="numeroPuntoVentaValido"
                type="number"
                min="0000" max="9999"
                :readonly="numeroPuntoVentaDisabled"
                @blur.native="validate">
              </b-form-input>
              <b-form-input 
                id="numero"
                v-model.trim= "$v.numero.$model" 
                :state="numeroValido"
                type="number"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="numeroFeedback">
                {{ numeroInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </div>

          <b-form-group
            v-if="!puntoVentaVisible"
            label="Número"
            label-for="numero"
            :label-cols="2"
            horizontal>
            <b-form-input 
              id="numero"
              v-model.trim= "$v.numero.$model" 
              :state="numeroValido"
              type="number"
              @blur.native="validate">
            </b-form-input>
            <b-form-invalid-feedback id="numeroFeedback">
              {{ numeroInvalidoMsj }}
            </b-form-invalid-feedback>          
          </b-form-group>
        </b-col>

        <b-col xl="6">
          <b-form-group
            label="Fecha Comp."
            label-for="fechaComprobante"
            :label-cols="3"
            horizontal>
            <b-form-input 
              id="fechaComprobante" 
              v-model= "fechaComprobante" 
              type="date">
            </b-form-input>
          </b-form-group>

          <b-form-group
            label="Fecha Venc."
            label-for="fechaVencimiento"
            :label-cols="3"
            :description="leyendaPlazo"
            horizontal>
            <b-form-input 
              id="fechaVencimiento" 
              v-model= "fechaVencimiento" 
              type="date">
            </b-form-input>
          </b-form-group>

          <b-form-group
            label="Periodo"
            label-for="periodo"
            :label-cols="3"
            horizontal>
            <b-form-select 
              v-model="periodoMesNombre" 
              :options="meses" 
              :state="periodoValido"
              class="mb-3 select-fecha select-fecha-mes"
              @blur.native="validate">
              <template slot="first">
                <option :value='null'>Seleccione un mes</option>
                <!--<option :value='null' :disabled='Boolean(true)'>Seleccione un mes</option>-->
              </template>
            </b-form-select>
            <b-form-select 
              v-model="periodoAnio" 
              :options="anios" 
              :state="periodoValido"
              class="mb-3 select-fecha select-fecha-anio"
              @blur.native="validate">
              <template slot="first">
                <option :value="0">Seleccione un año</option>
                <!--<option :value="0" :disabled='Boolean(true)'>Seleccione un año</option>-->
              </template>
            </b-form-select>
            <b-form-invalid-feedback id="periodoFeedback">
              {{ periodoInvalidoMsj }}
            </b-form-invalid-feedback>          
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <b-modal ref="proveedorModal"
        title="Alta de Proveedores"
        modal-class="modalABM"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-proveedor
        @updateProveedor="updateProveedor"
        @closeProveedor="closeProveedor">
      </app-proveedor>  
    </b-modal>

    <b-modal ref="searchProveedorModal" 
        title="Seleccionar Proveedor"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="proveedores-search-modal">
      <app-search-proveedor
        @proveedorSeleccionado="proveedorSeleccionado">
      </app-search-proveedor>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>   
  </div>
</template>

<script>
import { required, requiredIf, minValue, maxValue, numeric } from 'vuelidate/lib/validators';
import Proveedor from '../proveedores/Alta.vue';
import SearchProveedor from '../proveedores/SearchList.vue'
import ComprobanteTipo from '../shared/abmSelectSimple.vue';
import Formulario from '../shared/abmSelectSimple.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'compra/getField',
  mutationType: 'compra/updateField',
});

// const NumeroComprobanteValido = ((value, vm) => {
//   console.log(value, vm.digitosNumeroComprobante)
//   if (value == 0) {
//     return false;
//   } else {
//     console.log(isNaN(parseInt(value)))
//     if (isNaN(parseInt(value))) {
//       return false;
//     } else {
//       let length = Math.log(value) * Math.LOG10E + 1 | 0; 
//       console.log(length) 
//       if (length != 0 & length != vm.digitosNumeroComprobante) {
//         return false;
//       }
//     }

//     return true;
//   }
// })

const NumeroComprobanteValido = ((value, vm) => {
  // Si no hay valor, es inválido
  if (!value || value === 0 || value === '0') {
    return false;
  }
  
  // Convertir a string para validar
  const valueStr = value.toString().trim();
  
  // Verificar que solo contenga dígitos
  if (!/^\d+$/.test(valueStr)) {
    return false;
  }
  
  // Verificar que no exceda los dígitos permitidos
  if (valueStr.length > vm.digitosNumeroComprobante) {
    return false;
  }
  
  // Verificar que no sea solo ceros
  if (parseInt(valueStr) === 0) {
    return false;
  }
  
  return true;
});

export default {
  name: 'ABM',
  props: {
    inicializando: {
      type: Boolean,
      default: false,
    },
    noValidar: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    appProveedor: Proveedor,
    appSearchProveedor: SearchProveedor,
    ComprobanteTipo,
    Formulario,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      proveedorValido: null,
      proveedorInvalidoMsj: '',
      periodoValido: null,
      periodoInvalidoMsj: '',
      comprobanteTipoValido: null,
      comprobanteInvalidoMsj: '',
      formularioValido: null,
      formularioInvalidoMsj: '',
      numeroPuntoVentaValido: null,
      numeroValido: null,
      numeroInvalidoMsj: '',

      meses: [],
      anios: []
    }
  },
  computed: {
    ...mapFields([
      'fechaComprobante',
      'fechaVencimiento',
      'periodo',
      'periodoMesNombre',
      'periodoAnio',
      'proveedor',
      'proveedorNombre',
      'comprobanteTipo',
      'comprobanteTipoNombre',
      'formulario',
      'formularios',
      'numeroPuntoVenta',
      'numero',
      'plazoPago',

      'comprobantesTipos',
      'comprobantesTiposList',
      'formularioDisabled',
      'numeroPuntoVentaDisabled', 
      'numeroDisabled',

      'formularioVisible',
      'puntoVentaVisible',
      'digitosNumeroComprobante'
    ]),
    leyendaPlazo() {
      if (this.plazoPago) {
        if (this.plazoPago != 0) {
          return `Plazo de Pago: ${this.plazoPago.toString().trim()} días`;
        }
      }
      return '';
    },
  },
  created() {
    this.getDatosAdicionales();
  },  
  methods: {
    getDatosAdicionales() {
      this.meses = this.getMeses();
      this.anios = this.getAniosPeriodo();
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'numeroPuntoVenta' || validarTodos) {
        if (this.$v.numeroPuntoVenta.$error) {
          this.numeroPuntoVentaValido = false;
          /*
          if (!this.$v.numeroPuntoVenta.required) {
            this.numeroPuntoVentaInvalidoMsj = 'Debe ingresar el número de punto de venta.';
          } else if (!this.$v.numeroPuntoVenta.numeric || !this.$v.numeroPuntoVenta.minValue || !this.$v.numeroPuntoVenta.maxValue) {
            this.numeroPuntoVentaInvalidoMsj = 'El número de punto de venta ingresado no es válido.';
          } 
          */    
        } else {
          this.numeroPuntoVentaValido = null;
          /*this.numeroPuntoVentaInvalidoMsj = '';*/
        }
      }

      if (campo == 'numero' || validarTodos) {
        if (this.$v.numero.$error) {
          this.numeroValido = false;
          /*
          if (!this.$v.numero.required) {
            this.numeroInvalidoMsj = 'Debe ingresar el número del comprobante.';
          } else if (!this.$v.numero.numeric || !this.$v.numero.minValue || !this.$v.numero.maxValue) {
            this.numeroInvalidoMsj = 'El número de comprobante ingresado no es válido.';
          } 
          */   
        } else {
          this.numeroValido = null;
          /*this.numeroInvalidoMsj = '';*/
        }
      }

      if (!this.numeroValido || !this.numeroPuntoVentaValido) {
        this.numeroInvalidoMsj = 'Verifique la numeración del comprobante';
      } else {
        this.numeroInvalidoMsj = '';
      }
    },
    save() {
      let save = true;

      let proveedorError = true;
      if (this.proveedor) {
        if (this.proveedor.id) {
          if (this.proveedor.id != 0) {
            proveedorError = false;
          }
        }
      }
      if (proveedorError) {
        save = false;
        this.proveedorValido = false;
        this.proveedorInvalidoMsj = 'Debe seleccionar el proveedor correspondiente.';
      } else {
        this.proveedorValido = null;
        this.proveedorInvalidoMsj = '';
        
      }

      let comprobanteTipoError = true;
      if (this.comprobanteTipo) {
        if (this.comprobanteTipo.id) {
          if (this.comprobanteTipo.id != 0) {
            comprobanteTipoError = false;
          }
        }
      }
      if (comprobanteTipoError) {
        save = false;
        this.comprobanteTipoValido = false;
        // this.comprobanteInvalidoMsj = "Debe seleccionar el tipo de comprobante correspondiente.";
      } else {
        this.comprobanteTipoValido = null;
      }

      let formularioError = false;
      
      if (this.formularioVisible) {
        formularioError = true;
        if (this.formulario) {
          if (this.formulario.trim() != '') {
            formularioError = false;
          }
        }
  
        if (formularioError) {
          save = false;
          this.formularioValido = false;
          // this.comprobanteInvalidoMsj = "Debe seleccionar el formulario correspondiente.";
        } else {
          this.formularioValido = null;
        }
      }

      this.comprobanteInvalidoMsj = '';
      if (comprobanteTipoError & formularioError) {
        this.comprobanteInvalidoMsj = 'Debe seleccionar el tipo de comprobante y formulario correspondiente.';
      } else if (comprobanteTipoError) {
        this.comprobanteInvalidoMsj = 'Debe seleccionar el tipo de comprobante correspondiente.';
      } else if (formularioError) {
        this.comprobanteInvalidoMsj = 'Debe seleccionar el formulario correspondiente.';
      }

      let mes = this.getMesNumero(this.periodoMesNombre);
      let anio = parseInt(this.periodoAnio);

      if (!this.isValidDate(1, mes, anio))
      {
        this.periodoValido = false;
        this.periodoInvalidoMsj = 'Debe seleccionar el período del comprobante.';
        save = false;
      } else {
        this.periodoValido = null;
        this.periodoInvalidoMsj = '';
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
        save = false;
      }

      return save;
    },
    seleccionarProveedor() {
      this.$refs.searchProveedorModal.show()
    },
    proveedorSeleccionado(item) {
      this.$store.dispatch('compra/setProveedor', item)
      this.$refs.searchProveedorModal.hide();
      this.proveedorValido = null;
      this.proveedorInvalidoMsj = '';
    },
    agregarProveedor() {
      this.$refs.proveedorModal.show();
    },
    updateProveedor(proveedor) {
      let proveedorDatos = {
        id: proveedor.id,
        nombre: proveedor.nombreComercial.trim(),
        formaPagoPlazo: 0
      }

      this.$refs.proveedorModal.hide();
      this.$store.dispatch('compra/setProveedor', proveedorDatos)
        .catch(error => this.showErrorMsj(error));
    },
    closeProveedor() {
      this.$refs.proveedorModal.hide();
    },
    comprobanteTipoActualizado(comprobanteTipoNombre) {
      if (!this.inicializando) {
        this.comprobanteTipoNombre = comprobanteTipoNombre;

        let comprobanteTipo;
        if (this.comprobanteTipoNombre) {
          comprobanteTipo = this.getSelected(this.comprobantesTipos, this.comprobanteTipoNombre);
        }
        
        this.$store.dispatch('compra/setComprobanteTipo', comprobanteTipo);
        this.$store.dispatch('compra/calcularMontos')

        this.comprobanteTipoValido = null;
        if (this.formularioValido == null) {
          this.comprobanteInvalidoMsj = '';
        }
      }
    },    
    formularioActualizado(formulario) {
      if (!this.inicializando) {
        this.formulario = formulario;

        this.formularioValido = null;
        if (this.comprobanteTipoValido == null) {
          this.comprobanteInvalidoMsj = '';
        }
      }
    },    
  },
  validations: {
    // formulario: {
    //   required
    // },
    numeroPuntoVenta: {
      required: requiredIf(function () {
        return this.puntoVentaVisible;
      }),
      numeric,
      minValue: minValue(0),
      maxValue: maxValue(9999)
    },
    numero: {
      NumeroComprobanteValido
      // required,
      // numeric,
      // minValue: minValue(1),
      // maxValue: maxValue(99999999)
    },
  },  
  watch: {
    'fechaComprobante' : function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.$store.dispatch('compra/calcularFechaVencimiento');
      }
    },
    'formulario' : function(newVal, oldVal) {
      this.$store.dispatch('compra/calcularMontosTotal')
    },
  },
}
</script>

<style>
</style>
